// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextSection_wrapper____LaG","title":"TextSection_title__2_OGd","subtitle":"TextSection_subtitle__L7FAp","text":"TextSection_text__c_Lpe"};